// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { Component, ChangeDetectionStrategy, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonComponent } from '@lfx/shared/components/button';
import { EmptyStateConfig } from '@lfx/key-projects/key-projects.model';

@Component({
  selector: 'lfx-empty-state',
  imports: [CommonModule, ButtonComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="empty-state">
      <div class="empty-state-content">
        <div class="empty-state-icon">
          <!-- Custom Image Icon -->
          @if (config().iconSrc) {
            <img [src]="config().iconSrc"
                 alt="Empty state icon"
                 class="custom-icon"
                 [attr.aria-label]="config().title">
          }

          <!-- FontAwesome Icon -->
          @if (!config().iconSrc && config().iconClass) {
            <i [class]="config().iconClass"
               [attr.aria-label]="config().title">
            </i>
          }

          <!-- Default Folder Icon -->
          @if (!config().iconSrc && !config().iconClass) {
            <img src="assets/img/svgs/folder-empty.svg"
                 alt="Empty folder"
                 class="folder-icon"
                 [attr.aria-label]="config().title">
          }
        </div>
        <h3 class="empty-state-title lf-heading-md">{{ config().title }}</h3>
        <p class="empty-state-message lf-body-sm" [innerHTML]="config().message"></p>
        @if (config().showAction) {
          <lfx-button
            variant="primary"
            size="small"
            [icon]="config().buttonIcon || 'fa-folder-plus'"
            (click)="onActionClick()">
            {{ config().actionText }}
          </lfx-button>
        }
      </div>
    </div>
  `,
  styleUrls: ['./empty-state.component.scss']
})
export class EmptyStateComponent {
  readonly config = input.required<EmptyStateConfig>();
  readonly actionClicked = output<void>();

  protected onActionClick(): void {
    this.actionClicked.emit();
  }
}
